import React, { useState } from 'react'
import { Col, Image, Modal, Row } from 'react-bootstrap'
import { brandImage4, brandImage6, clubPlusImage, enlargeIcon, logoBlack } from '../../assets'

export default function Section6() {
    const [ShowImageEnlargeModal, setShowImageEnlargeModal] = useState(false)

    return (
        <Row className='section4 mx-0'>
            <Modal show={ShowImageEnlargeModal} onHide={() => setShowImageEnlargeModal(false)}>
                <Image src={clubPlusImage} width='100%' />
            </Modal>

            <Col lg={6} className='d-flex flex-column justify-content-center  align-items-center'>
                <div style={{cursor:'pointer'}} onClick={() => setShowImageEnlargeModal(true)}>
                    <Image src={clubPlusImage} width='256px' height='205px' style={{boxShadow:'0px 25px 45px #000000'}}/>
                    <div className='d-flex align-items-center w-100 justify-content-center mb-3 mt-3'>
                        <Image src={enlargeIcon} width='21px' height='21px' />
                        <p className='mb-0' style={{color:'white',fontWeight:'700'}}>CLICK TO ENLARGE</p>
                    </div>
                </div>
                <Image src={brandImage6} height='313px' className='brand-image2'/>
            </Col>
            <Col lg={6} className='d-flex flex-column justify-content-center align-items-center'>
                <Image src={logoBlack} width='382px' height='auto' />
                <Row className='mx-0 w-100' style={{ fontWeight: '500', marginTop: '20px', marginBottom: '41px' }}>
                    <Col className='ps-0 col-auto'>
                        <ul>
                            <li style={{ textAlign: 'start' }}>Chemically treated in 3 stages</li>
                            <li style={{ textAlign: 'start' }}>Vacuum pressure treated</li>
                            <li style={{ textAlign: 'start' }}>Free from toxic emission</li>
                        </ul>
                    </Col>
                    <Col className='ps-0 ps-md-2 col-12 col-md-6'>
                        <ul>
                            <li style={{ textAlign: 'start' }}>Quad press technology</li>
                            <li style={{ textAlign: 'start' }}>Superior quality wood</li>
                            <li style={{ textAlign: 'start' }}>Super strong bonding</li>
                            <li style={{ textAlign: 'start' }}>Borer proof</li>
                        </ul>
                    </Col>
                </Row>
                <Image src={brandImage4} className='brand-image2' />
            </Col>
        </Row>
    )
}
